import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CheckIcon from "../../assets/img/svg/documents/si.svg";
import Expirado from "../../assets/img/svg/documents/exp.svg";
import AExpirarIcon from "../../assets/img/svg/documents/aexp.svg";
import Eliminar from "../../assets/img/svg/documents/eliminar.svg";
import No from "../../assets/img/svg/documents/no.svg";
import Descargar from "../../assets/img/svg/documents/descargar.svg";
import { Document, Page, pdfjs } from "react-pdf";
import {
  deleteCompanyFile,
  uploadCompanyContract,
} from "../functions/Functions";
import "./documentsInstallers.css";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import { validarArchivo } from "../../utils/aiValidationUtils";
import Visible from "../../assets/img/svg/providers/ver.svg";
import SelectFile from "../../assets/img/svg/providers/selectFile.svg";
import Cargar from "../../assets/img/svg/providers/cargar.svg";
import Opciones from "../../assets/img/svg/users/opciones.svg";
import CustomButton from "../../ui/button/Button";
import Descarga from "../../assets/img/svg/users/descargar.svg";
import Subir from "../../assets/img/svg/providers/CargarVerde.svg";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const tiposDocumento = ["CONTRATO", "COMPROBANTE", "SIPARE", "REPSE", "SUA"];

const UploadContractForm = ({
  API_URL,
  empresaId,
  onUploadSuccess,
  documentosExistentes = {},
  previewsExistentes = {},
}) => {
  const [archivos, setArchivos] = useState({});
  const [fechas, setFechas] = useState({});
  const [previews, setPreviews] = useState(previewsExistentes);
  const [modal, setModal] = useState({
    abierto: false,
    url: "",
    extension: "",
  });
  const [numPages, setNumPages] = useState(null);
  const [versiones, setVersiones] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);
  const showDialog = useConfirmDialog();
  const [validaciones, setValidaciones] = useState({});
  //  const [modalVersiones, setModalVersiones] = useState(null);
  const [modalVersiones, setModalVersiones] = useState(null);
  // controla qué menú (tipo-index) está abierto
  const [openMenuId, setOpenMenuId] = useState(null);

  useEffect(() => {
    const inicial = {};
    tiposDocumento.forEach((tipo) => {
      inicial[tipo] = 0;
    });
    setVersiones(inicial);
  }, []);

  useEffect(() => {
    const nuevasPreviews = {};

    Object.entries(previewsExistentes).forEach(([id, url]) => {
      nuevasPreviews[id] = {
        url,
        extension: url.includes(".pdf") ? "pdf" : "image",
        name: `documento-${id}`, // nombre genérico, ajusta como prefieras
        file: null, // No tienes acceso al archivo original desde URL, será null
      };
    });

    setPreviews(nuevasPreviews);
  }, [previewsExistentes]);

  const getBorderClassFromFecha = (fecha) => {
    if (!fecha) return "border-red";
    const f = new Date(fecha);
    const hoy = new Date();
    const pronto = new Date();
    pronto.setDate(hoy.getDate() + 60);
    if (f < hoy) return "border-red";
    if (f <= pronto) return "border-yellow";
    return "border-green";
  };

  const handleFileChange = async (tipo, file, index = 0) => {
    const key = `${tipo}-${index}`;
    const url = URL.createObjectURL(file);
    const extension = file.type.includes("pdf") ? "pdf" : "image";

    let isValid = {
      blurry: false,
      bright: false,
      isCropped: false,
      hasFace: true,
    };

    // SOLO validar si NO es PDF
    if (extension !== "pdf") {
      isValid = await validarArchivo(file);
    }

    setArchivos((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: {
        url,
        extension,
        name: file.name,
        file,
      },
    }));

    setValidaciones((prev) => ({
      ...prev,
      [key]: isValid,
    }));
  };

  const handleUpload = async (tipo, index = 0) => {
    const key = `${tipo}-${index}`;
    const doc = documentosExistentes.find(
      (d) => d.tipoDocumento?.name === tipo
    );

    const fecha = fechas[key] || doc?.fechaVencimiento;
    const archivo = archivos[key] || previews[key]?.file;

    if (!archivo) {
      return showDialog({
        icon: "warning",
        html: "Falta seleccionar el archivo. Por favor, selecciónalo nuevamente.",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }

    if (!fecha) {
      return showDialog({
        icon: "warning",
        html: "Falta la fecha de vencimiento.",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }

    const resultado = await validarArchivo(archivo);
    if (
      resultado.blurry ||
      resultado.bright ||
      resultado.isCropped ||
      !resultado.hasFace
    ) {
      return showDialog({
        icon: "warning",
        html: "El archivo no cumple con los requisitos de calidad.",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }

    try {
      const fechaAjustada = new Date(fecha);
      fechaAjustada.setHours(12, 0, 0, 0);

      await uploadCompanyContract(
        API_URL,
        empresaId,
        tipo,
        fechaAjustada.toISOString(),
        archivo,
        ""
      );

      showDialog({
        icon: "success",
        html: `${tipo} subido correctamente`,
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });

      if (onUploadSuccess) {
        onUploadSuccess();
      }
    } catch (err) {
      showDialog({
        icon: "error",
        html: "Error al subir el documento",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteCompanyFile(API_URL, id);
      showDialog({
        icon: "success",
        html: "Documento eliminado",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
      if (onUploadSuccess) {
        onUploadSuccess();
        setRefreshKey((prev) => prev + 1);
      }
    } catch (err) {
      showDialog({
        icon: "error",
        html: "Error al eliminar",
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }
  };

  const documentosAgrupados = tiposDocumento.map((tipo) => {
    const docsDelTipo = documentosExistentes.filter(
      (d) => d.tipoDocumento?.name === tipo
    );

    const versionesOrdenadas = [...docsDelTipo].sort(
      (a, b) => new Date(b.fechaVencimiento) - new Date(a.fechaVencimiento)
    );

    return {
      tipo,
      documento: versionesOrdenadas[0] || null, // el más reciente o null si no existe
      versiones: versionesOrdenadas,
    };
  });

  const getStatusIconFromFecha = (fecha, doc) => {
    const hasFile = !!doc?.id;
    if (!hasFile) return No;
    if (!fecha) return Expirado;

    const f = new Date(fecha);
    const hoy = new Date();
    const pronto = new Date();
    pronto.setDate(hoy.getDate() + 60);

    if (f < hoy) return Expirado;
    if (f <= pronto) return AExpirarIcon;
    return CheckIcon;
  };

  const addVersion = (tipo) => {
    setVersiones((prev) => {
      const actual = prev[tipo] || 0;
      return { ...prev, [tipo]: actual + 1 };
    });
  };

  const hayVersionesAnteriores = tiposDocumento.some(
    (tipo) =>
      documentosExistentes.filter((d) => d.tipoDocumento?.name === tipo)
        .length > 1
  );

  // Descarga usando la URL de preview que heredamos del padre (previewsExistentes)
  const handleInlineDownload = (doc) => {
    if (!doc?.id) return;
    const url = previewsExistentes[doc.id];
    if (!url) return;

    // arma nombre de archivo
    const base =
      doc?.nombre || doc?.tipoDocumento?.name || `documento-${doc.id}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = `${base}.pdf`; // ajusta si puede ser imagen
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  // Crea una nueva versión y abre el input de archivo de esa nueva fila
  const handleAddNewForTipo = (tipo, currentIndex) => {
    // agrega una versión vacía
    addVersion(tipo);
    setRefreshKey((prev) => prev + 1);

    // tras el re-render, abre el input de la siguiente fila
    setTimeout(() => {
      const nextIndex = currentIndex + 1;
      const input = document.getElementById(`file-${tipo}-${nextIndex}`);
      if (input) input.click();
    }, 0);
  };

  return (
    <div key={refreshKey} className="documents-container">
      {modalVersiones === "TODOS" && (
        <div className="preview-modal" onClick={() => setModalVersiones(null)}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            {documentosAgrupados
              .filter(({ tipo }) => !["SUA", "SIPARE"].includes(tipo))
              .map(({ tipo, versiones }) => (
                <div key={tipo} style={{ marginBottom: "20px" }}>
                  <h3
                    style={{
                      fontFamily: "Nunito",
                      fontWeight: 700,
                      fontSize: "16px",
                      color: "#223D51",
                      marginBottom: "10px",
                      borderBottom: "1px solid #C3C3C3",
                      paddingBottom: "5px",
                      textAlign: "left",
                    }}
                  >
                    {tipo === "REPSE"
                      ? "REPSE"
                      : tipo.charAt(0).toUpperCase() +
                        tipo.slice(1).toLowerCase()}
                  </h3>

                  {/* 🔹 LISTADO DE VERSIONES ANTERIORES */}
                  {versiones.slice(1).map((doc) => {
                    const preview = previewsExistentes[doc.id]
                      ? {
                          url: previewsExistentes[doc.id],
                          extension: /\.pdf$/i.test(doc.nombre)
                            ? "pdf"
                            : "image",
                          name: doc.nombre,
                        }
                      : null;

                    return (
                      <div className="document-box document-white" key={doc.id}>
                        <div className="document-box-status">
                          <img
                            src={getStatusIconFromFecha(
                              doc?.fechaVencimiento,
                              doc
                            )}
                            alt="status"
                          />
                        </div>
                        <div className="document-box-name">
                          <div className="document-preview">
                            <div
                              className="doc-preview-box clickable"
                              onClick={() => {
                                if (preview?.url) {
                                  setModal({
                                    abierto: true,
                                    url: preview.url,
                                    extension: preview.extension,
                                    name: preview.name,
                                  });
                                }
                              }}
                              style={{
                                width: "125px",
                                height: "27px",
                                border: "1px solid #C3C3C3",
                                borderRadius: "13.5px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "0 10px",
                                fontFamily: "Nunito",
                                fontSize: "12px",
                                color: "#223D51",
                                background: "#FFFFFF",
                                cursor: "pointer",
                              }}
                            >
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "90px",
                                }}
                              >
                                {tipo.charAt(0).toUpperCase() +
                                  tipo.slice(1).toLowerCase()}
                              </span>
                              <img
                                src={Visible}
                                alt="ver"
                                style={{ width: "16px", height: "16px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="document-box-date">
                          <DatePicker
                            selected={
                              doc.fechaVencimiento
                                ? new Date(doc.fechaVencimiento)
                                : null
                            }
                            className={`document-date-picker ${getBorderClassFromFecha(
                              doc.fechaVencimiento
                            )}`}
                            dateFormat="dd/MM/yyyy"
                            readOnly
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
          </div>
        </div>
      )}

      {hayVersionesAnteriores && (
        <div className="document-box-button">
          <CustomButton
            text={"Ver documentos anteriores"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#223D51"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"200px"}
            height={"28px"}
            type={"button"}
            onClick={() => setModalVersiones("TODOS")}
          />
        </div>
      )}
      <div className="column-tittles">
        <div className="col-state">Estatus</div>
        <div className="col-name">Documento</div>
        <div className="col-date">Fecha de vencimiento</div>
        <div className="col-actions">Actualiza el documento</div>
        <div className="col-options">Acciones</div>
      </div>
      {tiposDocumento.map((tipo) => {
        const docsDelTipo = documentosExistentes.filter(
          (d) => d.tipoDocumento?.name === tipo
        );

        const documento =
          docsDelTipo.sort(
            (a, b) =>
              new Date(b.fechaVencimiento) - new Date(a.fechaVencimiento)
          )[0] || null;
        const cantidadNuevas = versiones[tipo] || 0;
        const nuevasVersiones = Array.from(
          { length: cantidadNuevas },
          () => null
        );

        const allDocs =
          documento || nuevasVersiones.length > 0
            ? [documento, ...nuevasVersiones]
            : [null];

        return allDocs.map((doc, index) => {
          const key = `${tipo}-${index}`;

          const preview =
            previews[key] ||
            (doc && previewsExistentes[doc.id]
              ? {
                  url: previewsExistentes[doc.id],
                  extension: /\.pdf$/i.test(doc?.nombre) ? "pdf" : "image",
                  name: doc.nombre,
                }
              : null);

          const fecha = fechas[key] || doc?.fechaVencimiento;

          const getBorderClass = () => {
            if (!fecha) return "border-red";
            const f = new Date(fecha);
            const hoy = new Date();
            const pronto = new Date();
            pronto.setDate(hoy.getDate() + 60);
            if (f < hoy) return "border-red";
            if (f <= pronto) return "border-yellow";
            return "border-green";
          };

          return (
            <div key={key} className={`document-box document-white`}>
              <div className="document-box-status">
                <img src={getStatusIconFromFecha(fecha, doc)} alt="status" />
              </div>
              <div className="document-box-name">
                <div className="document-preview">
                  <div
                    className="doc-preview-box clickable"
                    onClick={() => {
                      if (preview?.url) {
                        setModal({
                          abierto: true,
                          url: preview.url,
                          extension: preview.extension,
                          name: preview.name,
                        });
                      } else {
                        document.getElementById(`file-${key}`).click();
                      }
                    }}
                    style={{
                      width: "125px",
                      height: "27px",
                      border: doc ? "1px solid #C3C3C3" : "none",
                      borderRadius: "13.5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 10px",
                      fontFamily: "Nunito",
                      fontSize: "12px",
                      color: "#223D51",
                      background: doc ? "#FFFFFF" : "#EDEDED",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "90px",
                      }}
                    >
                      {["DC3", "SIPARE", "REPSE", "SUA"].includes(tipo)
                        ? tipo
                        : tipo.charAt(0).toUpperCase() +
                          tipo.slice(1).toLowerCase()}
                    </span>
                    <img
                      src={preview?.url ? Visible : Cargar}
                      alt="icono"
                      style={{
                        width: preview?.url ? "16px" : "10px",
                        height: "16px",
                      }}
                    />
                  </div>
                  <input
                    type="file"
                    id={`file-${key}`}
                    accept=".jpg,.jpeg,.png,.pdf"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileChange(tipo, e.target.files[0], index)
                    }
                  />
                </div>
              </div>
              <div className="document-box-date">
                <DatePicker
                  selected={fecha ? new Date(fecha) : null}
                  onChange={(date) =>
                    setFechas((prev) => ({ ...prev, [key]: date }))
                  }
                  className={`document-date-picker ${getBorderClass()}`}
                  placeholderText="Sin datos"
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div className="document-box-button">
                {doc?.id ? (
                  // ✅ CON DOCUMENTO: menú de 3 puntos
                  <div
                    className="actions-menu"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <CustomButton
                      text={"Cargar nuevo"}
                      color={"#FFFFFF"}
                      border={"none"}
                      background={"#223D51"}
                      fontStyle={"normal"}
                      fontWeight={700}
                      fontSize={"14px"}
                      width={"129px"}
                      height={"31px"}
                      type={"button"}
                      icon={true} // ← solo muestra el icono si hay archivo
                      src={Subir}
                      iconW="12px"
                      iconM="5px"
                      onClick={() => {
                        handleAddNewForTipo(tipo, index);
                        setOpenMenuId(null);
                      }}
                    />
                  </div>
                ) : (
                  // ❌ SIN DOCUMENTO: botón único "Seleccionar/Subir"
                  <CustomButton
                    text={"Añadir"}
                    color={"#FFFFFF"}
                    border={"none"}
                    background={"#62C776"}
                    fontStyle={"normal"}
                    fontWeight={700}
                    fontSize={"14px"}
                    width={"129px"}
                    height={"31px"}
                    type={"button"}
                    disabled={
                      !archivos[`${tipo}-${index}`] ||
                      !fechas[`${tipo}-${index}`]
                    } // opcional: deshabilita si falta archivo o fecha
                    onClick={() => handleUpload(tipo, index)} // ← SUBE aquí, como antes
                  />
                )}
              </div>
              <div className="document-box-options">
                {doc?.id ? (
                  // ✅ CON DOCUMENTO: menú de 3 puntos
                  <div
                    className="actions-menu"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <button
                      type="button"
                      className="actions-trigger"
                      aria-haspopup="true"
                      aria-expanded={openMenuId === `${tipo}-${index}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenMenuId((prev) =>
                          prev === `${tipo}-${index}`
                            ? null
                            : `${tipo}-${index}`
                        );
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        padding: "4px 8px",
                      }}
                      title="Acciones"
                    >
                      <img
                        src={Opciones}
                        alt="Opciones"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </button>

                    {openMenuId === `${tipo}-${index}` && (
                      <ul
                        role="menu"
                        className="actions-dropdown-doc-up"
                        style={{
                          position: "absolute",
                          right: 0,
                          top: "100%",
                          zIndex: 20,
                          minWidth: 180,
                          background: "#fff",
                          border: "1px solid #e5e7eb",
                          borderRadius: 8,
                          padding: "6px 0",
                          margin: 0,
                          boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                          listStyle: "none",
                          color: "#000",
                          fontFamily: "Nunito",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <li
                          role="menuitem"
                          className="menu-item-doc-up"
                          onClick={() => {
                            handleInlineDownload(doc);
                            setOpenMenuId(null);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={Descarga}
                            alt="Descargar"
                            width={16}
                            height={16}
                          />
                          Descargar
                        </li>

                        <li
                          role="menuitem"
                          className="menu-item-doc-up"
                          onClick={() => {
                            handleDelete(doc.id);
                            setOpenMenuId(null);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={Eliminar}
                            alt="ELiminar"
                            width={16}
                            height={16}
                          />
                          Eliminar
                        </li>
                      </ul>
                    )}
                  </div>
                ) : (
                  // 🚫 SIN DOCUMENTO: solo icono sin acción
                  <div
                    className="actions-menu"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <span
                      className="actions-trigger--disabled"
                      aria-hidden="true"
                      style={{
                        display: "inline-block",
                        padding: "4px 8px",
                        cursor: "default",
                        userSelect: "none",
                      }}
                      title="Sin acciones disponibles"
                    >
                      <img
                        src={Opciones}
                        alt="Opciones (sin acciones)"
                        style={{
                          width: "20px",
                          height: "20px",
                          pointerEvents: "none",
                        }}
                      />
                    </span>
                  </div>
                )}
              </div>
              ;
            </div>
          );
        });
      })}

      {modal.abierto && (
        <div
          className="preview-modal"
          onClick={() => setModal({ abierto: false, url: "", extension: "" })}
        >
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            <div>
              <button
                className="upload-button-plus"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = modal.url;
                  link.download = modal.name || `documento.${modal.extension}`;
                  link.click();
                }}
              >
                <img alt="descargar" src={Descargar} />
              </button>
            </div>
            {modal.extension === "pdf" ? (
              <Document
                file={modal.url}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                onLoadError={(err) => console.error("Error cargando PDF:", err)}
                error={<div>Error cargando el documento PDF</div>}
              >
                {Array.from(new Array(numPages), (_, i) => (
                  <Page key={i} pageNumber={i + 1} width={600} />
                ))}
              </Document>
            ) : (
              <img src={modal.url} alt="preview" style={{ maxWidth: "90%" }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadContractForm;
